export default [
  "Botswana",
  "Afghanistan",
  "Andorre",
  "Antigua-et-Barbuda",
  "Aruba",
  "Bahamas",
  "Bangladesh",
  "Barbade",
  "Belize",
  "Bermudes",
  "Bhoutan",
  "Birmanie",
  "Brunei",
  "Burundi",
  "Cambodge",
  "Chypre",
  "Comores",
  "Corée du Nord",
  "Dominique",
  "Eswatini",
  "Gabon",
  "Grenade",
  "Guam",
  "Guyana",
  "Honduras",
  "Îles Caïmans",
  "Îles Cook",
  "Îles Marshall",
  "Îles Vierges britanniques",
  "Îles Vierges des États-Unis",
  "Indonésie",
  "Jordanie",
  "Kirghizistan",
  "Kiribati",
  "Koweït",
  "Laos",
  "Liberia",
  "Libye",
  "Liechtenstein",
  "Madagascar",
  "Malaisie",
  "Malawi",
  "Maldives",
  "Malte",
  "Maurice",
  "Micronésie",
  "Monaco",
  "Mongolie",
  "Monténégro",
  "Nauru",
  "Népal",
  "Nicaragua",
  "Niger",
  "Oman",
  "Palaos",
  "Palestine",
  "Papouasie-Nouvelle-Guinée",
  "République du Congo",
  "Rwanda",
  "Saint-Christophe-et-Niévès",
  "Sainte-Lucie",
  "Saint-Marin",
  "Saint-Vincent-et-les-Grenadines",
  "Salomon",
  "Salvador",
  "Samoa américaines",
  "Sao Tomé-et-Principe",
  "Seychelles",
  "Sierra Leone",
  "Somalie",
  "Soudan",
  "Sri Lanka",
  "Syrie",
  "Tadjikistan",
  "Tchad",
  "Thaïlande",
  "Timor oriental",
  "Togo",
  "Tonga",
  "Turkménistan",
"Tuvalu",
"Vanuatu",
"Venezuela",
  "Yémen",
    "Paraguay",
    "Irak",
    "Ouzbékistan",
    "Soudan du Sud",
   "Russie",
    "Angola",
    "Cap Vert",
    "Côte d'Ivoire",
    "Ghana",
    "Guinée Equatoriale",
    "Guinée",
    "Lettonie",
    "Luxembourg",
    "Mali",
    "Mauritanie",
    "Mozambique",
    "Namibie",
    "République Démocratique du Congo",
    "Zambie",
    "Albanie",
    "Angleterre",
    "Chili",
    "Colombie",
    "Ecosse",
    "Gibraltar",
    "Haiti",
    "Irlande du Nord",
    "Islande",
    "Macédoine du Nord",
    "Panama",
    "Pays de Galles",
    "Afrique du Sud",
    "Algérie",
    "Allemagne",
    "Arabie Saoudite",
    "Argentine",
    "Arménie",
    "Athlètes Individuels Neutres",
    "Australie",
    "Autriche",
    "Azerbaïdjan",
    "Bahreïn",
    "Belgique",
    "Bolivie",
    "Bosnie-Herzégovine",
    "Brésil",
    "Bulgarie",
    "Burkina Faso",
    "Cameroun",
    "Canada",
    "Chine",
    "Corée du Sud",
    "Costa Rica",
    "Croatie",
    "Cuba",
    "Danemark",
    "Djibouti",
    "Égypte",
    "Émirats Arabes Unis",
    "Équateur",
    "Équipe Olympique des Réfugiés",
    "Érythrée",
    "Espagne",
    "Estonie",
    "États-Unis",
    "Éthiopie",
    "Fidji",
    "Finlande",
    "France",
    "Gambie",
    "Géorgie",
    "Grande-Bretagne",
    "Grèce",
    "Guatemala",
    "Guinée-Bissau",
    "Hong Kong",
    "Hongrie",
    "Inde",
    "Iran",
    "Irlande",
    "Israël",
    "Italie",
    "Jamaïque",
    "Japon",
    "Kazakhstan",
    "Kenya",
    "Kosovo",
    "Liban",
    "Lituanie",
    "Maroc",
    "Mexique",
    "Moldavie",
    "Nigeria",
    "Norvège",
    "Nouvelle-Zélande",
    "Ouganda",
    "Pakistan",
    "Pays-Bas",
    "Pérou",
    "Philippines",
    "Pologne",
    "Porto Rico",
    "Portugal",
    "Qatar",
    "République Dominicaine",
    "Roumanie",
    "Samoa",
    "Sénégal",
    "Serbie",
    "Singapour",
    "Slovaquie",
    "Slovénie",
    "Suède",
    "Suisse",
    "Suriname",
    "Taipei Chinois",
    "Tanzanie",
    "Tchéquie",
    "Trinité-et-Tobago",
    "Tunisie",
    "Turquie",
    "Ukraine",
    "Uruguay",
    "Viêt Nam",
    "Zimbabwe",
    "Bénin",
  ];